import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-progress',
    styleUrls: ['./progress.component.sass'],
    template: `
        <div class="loader"></div>
    `
})
export class ProgressComponent implements OnInit {
    constructor() {}
    ngOnInit() {}
}
